import {
  clearTenantBranding,
  clearTenantBrandingStorage,
} from "utils/tenantBranding"
import logger from "utils/logger"

export const SESSION_ENDED_EVENT = "app:session-ended"

const AUTH_STORAGE_KEYS = [
  "authUser",
  "refreshToken",
  "isLoggedIn",
  "accountType",
  "accountScope",
  "tenantId",
  "tenantBranding",
]

const SESSION_STORAGE_KEYS = [
  "TENANT_ID",
  "tenantLoginRedirect",
  "forgotEmail",
]

/**
 * Remove auth and tenant keys from browser storage.
 * Does not touch user preferences (language, layout).
 * Intentionally does not import tokenManager (it loads api → circular deps).
 */
export const clearAuthAndTenantStorage = () => {
  try {
    AUTH_STORAGE_KEYS.forEach(key => {
      try {
        localStorage.removeItem(key)
      } catch {
        // ignore
      }
    })
    clearTenantBrandingStorage()
    SESSION_STORAGE_KEYS.forEach(key => {
      try {
        sessionStorage.removeItem(key)
      } catch {
        // ignore
      }
    })
  } catch (err) {
    logger.error("clearAuthAndTenantStorage error", err)
  }
}

/**
 * Clear storage + DOM branding + notify context listeners.
 * Safe to import from axios interceptors (no Redux/store dependency).
 */
export const clearClientSessionState = ({
  clearDom = true,
  notify = true,
} = {}) => {
  clearAuthAndTenantStorage()
  if (clearDom) {
    clearTenantBranding()
  }
  if (notify && typeof window !== "undefined") {
    window.dispatchEvent(new Event(SESSION_ENDED_EVENT))
  }
}

/** Hard redirect to login after clearing session (401 / refresh failure). */
export const redirectToLoginAfterSessionEnd = (loginPath = "/login") => {
  clearClientSessionState()
  window.location.href = loginPath
}
